import '.ci{font-size:1.125rem;}.ssr-plugin'
import '.gl{line-height:1.75rem;}.ssr-plugin'
import '.bw{text-decoration:none;}.ssr-plugin'
import '.e4{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ci gl"
    >
      {translations.privacySubtitle}{' '}
      <a className="bw e4"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="bw e4"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
